module.exports = __webpack_public_path__ + "static/media/e.ce66031b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/e.mp3
// module id = 94
// module chunks = 0